import { render, staticRenderFns } from "./CustomUserDropdown.vue?vue&type=template&id=0991ce99&scoped=true"
import script from "./CustomUserDropdown.vue?vue&type=script&lang=js"
export * from "./CustomUserDropdown.vue?vue&type=script&lang=js"
import style0 from "./CustomUserDropdown.vue?vue&type=style&index=0&id=0991ce99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0991ce99",
  null
  
)

export default component.exports